
import React, {Fragment, useState} from 'react';
import {isEmpty} from 'lodash';
import TextInput from '@sabre/spark-react-core/text-input';
import Button from '@sabre/spark-react-core/button';
import Icon from '@sabre/spark-react-core/icon';
import Tooltip from '@sabre/spark-react-core/tooltip';
import {SIZE} from '../../../utils/constants.js';

const SearchCriteriaModalFooterContent = ({
                                              isEmptyFieldPresent,
                                              setSelectedSavedCriteria,
                                              searchCriteriaModalCloseOnClickHandler,
                                              searchCriteriaClearButtonOnClickHandler,
                                              searchCriteriaSearchButtonOnClickHandler,
                                              searchCriteriaSaveButtonOnClickHandler,
                                          }) => {
    const [saveSearchCriteriaText, setSaveSearchCriteriaText] = useState('');

    const handleSaveSearchCriteriaTextOnChange = (selectedValue) => {
        setSaveSearchCriteriaText(selectedValue);
    }

    return (
        <Fragment>
            <div className='row spark-mar-t-1'>
                <div className='col-sm-12 col-md-6'>
                    <TextInput
                        className={isEmptyFieldPresent && isEmpty(saveSearchCriteriaText) ? 'spark-pull-left tb-save-criteria-as border-error' : 'spark-pull-left tb-save-criteria-as'}
                        placeHolder='Save Criteria As'
                        name='save-criteria-as'
                        label='Save Criteria As'
                        value={saveSearchCriteriaText}
                        onChange={selectedValue => handleSaveSearchCriteriaTextOnChange(selectedValue.target.value)}
                    />
                    <div className='spark-popover-group spark-mar-t-1'>
                        &nbsp;&nbsp;
                        <Tooltip
                            anchorX='top'
                            toggleEl={<Icon name='info-circle' style='fill' size={SIZE.MEDIUM}
                                            label='This field is not encrypted. Please do not enter any personal data.'
                                            onClick={() => {}}/>}
                        >This field is not encrypted. Please do not enter any personal data.
                        </Tooltip>
                        &nbsp;&nbsp;
                        <Tooltip
                            anchorX='top'
                            toggleEl={<Icon name='save' style='fill' size={SIZE.MEDIUM} label='Save!'
                                            onClick={() => searchCriteriaSaveButtonOnClickHandler(saveSearchCriteriaText)}
                            />}
                        >Save!
                        </Tooltip>
                    </div>
                </div>

                <div className='col-xs-12 col-sm-5'>
                    <nav className='spark-btn-group spark-mar-t-1'>
                        <Button
                            className='spark-btn-group-secondary'
                            size={Button.SIZE.SMALL}
                            secondary
                            onClick={searchCriteriaModalCloseOnClickHandler}
                        >
                            Cancel
                        </Button>
                        <Button
                            className='spark-btn-group-secondary'
                            size={Button.SIZE.SMALL}
                            secondary
                            onClick={() => {handleSaveSearchCriteriaTextOnChange('');
                                setSelectedSavedCriteria('');
                                searchCriteriaClearButtonOnClickHandler()}}
                        >
                            Reset
                        </Button>
                        <Button
                            className='spark-btn-group-primary'
                            size={Button.SIZE.SMALL}
                            onClick={() => {searchCriteriaSearchButtonOnClickHandler()}}
                        >
                            Search
                        </Button>
                    </nav>
                </div>
            </div>
        </Fragment>
    );
};

SearchCriteriaModalFooterContent.propTypes = {};

export default SearchCriteriaModalFooterContent;
